import { z } from 'zod';
import { parseStrictDate } from './strict-date.js';
/** Optional date field: `undefined` leaves it unchanged, `null`/`''` clears it. */
export const optionalNullableDateInput = z
    .union([z.string(), z.date(), z.null()])
    .optional()
    .transform((value, context) => {
    if (value === undefined)
        return undefined;
    if (value === null || value === '')
        return null;
    return parseStrictDate(value, context);
});
//# sourceMappingURL=optional-nullable-date-input.js.map